import { Link } from "react-router-dom";
import { ArrowRight, Trophy } from "lucide-react";

const IMG = (id, w = 900) => `https://images.unsplash.com/${id}?w=${w}&q=80&auto=format&fit=crop`;
const COLLAGE = [
  { src: IMG("photo-1531123897727-8f129e1688ce", 1000), alt: "Artist portrait", clip: "polygon(0 0, 50% 0, 38% 100%, 0 100%)", z: 4 },
  { src: IMG("photo-1470229722913-7c0e2dbbafd3"), alt: "Concert crowd", clip: "polygon(48% 0, 68% 0, 56% 100%, 36% 100%)", z: 3 },
  { src: IMG("photo-1566737236500-c8ac43014a67"), alt: "Night club", clip: "polygon(66% 0, 84% 0, 72% 100%, 54% 100%)", z: 2 },
  { src: IMG("photo-1508807526345-15e9b5f4eaff"), alt: "Dancer on stage", clip: "polygon(82% 0, 100% 0, 100% 100%, 70% 100%)", z: 1 },
];
const LINES = [[50, 38], [68, 56], [84, 72]];

export function Hero() {
  return (
    <section data-testid="hero" className="relative overflow-hidden bg-ivory">
      <div className="absolute inset-0 opacity-[0.06] pointer-events-none" style={{ backgroundImage: "url(https://upload.wikimedia.org/wikipedia/commons/8/80/World_map_-_low_resolution.svg)", backgroundSize: "70%", backgroundRepeat: "no-repeat", backgroundPosition: "right -20% top 20%" }} />
      <div className="container-wei grid lg:grid-cols-12 gap-8 lg:gap-6 items-center py-10 lg:py-6 min-h-[520px]">
        <div className="lg:col-span-6 relative z-10 fade-up">
          <p className="eyebrow text-ink/80 mb-5" data-testid="hero-eyebrow">Building the World’s Entertainment Record</p>
          <h1 className="font-serif font-bold tracking-tight leading-[0.95] text-[44px] sm:text-6xl lg:text-[72px] xl:text-[80px]" data-testid="hero-title">
            <span className="block text-ink">THE WORLD’S</span>
            <span className="block text-ink">ENTERTAINMENT</span>
            <span className="block gold-text">RECORD</span>
          </h1>
          <p className="mt-6 text-base sm:text-lg text-charcoal max-w-xl leading-relaxed">The global classification authority for entertainment. We rank and verify artists, DJs, actors, presenters, radio and TV stations, podcasts, night clubs, lounges, festivals and venues — by evidence, worldwide.</p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/rankings" data-testid="hero-rankings-btn" className="btn-bordeaux"><Trophy className="w-4 h-4 text-gold-light" /> View Classifications <ArrowRight className="w-4 h-4" /></Link>
            <Link to="/registry" data-testid="hero-explore-btn" className="btn-outline">Explore the Registry</Link>
            <Link to="/get-verified" data-testid="hero-verified-btn" className="btn-gold">Get Verified</Link>
          </div>
          <Link to="/claim" data-testid="hero-claim-btn" className="inline-block mt-4 text-sm text-bordeaux font-medium hover:underline">Claim your profile →</Link>
        </div>
        <div className="lg:col-span-6 relative h-[300px] sm:h-[380px] lg:h-[520px] fade-up delay-2" aria-label="Global entertainment collage">
          <div className="absolute inset-0 -left-6 lg:-left-16">
            {COLLAGE.map((c, i) => (
              <div key={i} className="absolute inset-0" style={{ clipPath: c.clip, zIndex: c.z }}>
                <img src={c.src} alt={c.alt} className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-ink/40 via-transparent to-transparent" />
              </div>
            ))}
            <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-ivory to-transparent z-10" />
            <svg className="absolute inset-0 w-full h-full z-10 pointer-events-none" preserveAspectRatio="none" viewBox="0 0 100 100">{LINES.map(([a, b]) => <line key={a} x1={a} y1="0" x2={b} y2="100" stroke="#C99738" strokeWidth="0.4" />)}</svg>
          </div>
        </div>
      </div>
    </section>
  );
}
